<template>
  <div class="team">
    <!--头部-->
    <Header title="团队" :show-back="false" />
    <van-tabs
      v-model="activeTab"
      background="#f9f9f9"
      title
      color="#1FC26D"
      line-height="3px"
      line-width="30px"
      title-active-color="#333"
      @click="changeTab"
    >
      <van-tab title="直推" name="direct">
        <TabContent type="direct" :data="directData" v-on:on-load="loadMore"/>
      </van-tab>
      <van-tab title="间推" name="indirect" >
         <TabContent type="indirect" :data="indirectData"/>
      </van-tab>
      <van-tab title="团队" name="team" >
         <TabContent type="team" :data="indirectData"/>
      </van-tab>
    </van-tabs>
    <Tabbar active="team"></Tabbar>
  </div>
</template>

<script>
import Header from "../../components/header";
import Tabbar from '../../components/tabbar'
 import TabContent from "./components/tabContent.vue"
export default {
  components: {
    Header,
    Tabbar,
    TabContent
  },
  data() {
    return {
      activeTab: "direct",
      directData:{
        all_coin:0,
        num:0,
        performance:0,
        list:{}
      },
      indirectData:{
        all_coin:0,
        num:0,
        performance:0,
        list:{}
      }
    };
  },
  created(){
   // this.getTeamData()
    console.log(this.activeTab)
  },
  methods:{


  }
};
</script>

<style lang="scss">
.team {
  padding: 40px 0 98px;
  .tab {
    @include flex($cross: space-between);
    padding: 93px;
    &-title {
      font-size: 32px;
      &.avtive {
        color: #333;
      }
    }

  }
}
</style>
